import { updateKeyInStore } from 'App';
import { AutomobilesStateValues, updateKey } from '../slice';

export const uploadFields: IBaseField<keyof AutomobilesStateValues | any>[] = [
  // {
  //   name: 'pleaseUploadCopyOfMileageLog',
  //   label: 'Please upload copy of Mileage Log.',
  //   type: 'upload',
  //   effect: updateKeyInStore(updateKey),
  //   predicate: (v) => v === 'yes',
  //   comment: true,
  //   dependentOn:
  //     'taxQuestionnaire.additionalQuestions.automobiles.values.didYouMaintainAMileageLogThisYear',
  // },
];
